export enum Statuses {
  TOPICKUP = 5,
  SCHEDULED = 10,
  BOOKEDIN = 15,
  FITTINGBOOKEDIN = 16,
  ASSIGNED = 20,
  WAITINGFORWORK = 20,
  WORKINGON = 25,
  WARRANTY = 26,
  WAITINGPARTS = 35,
  WAITINGCLIENT = 30,
  INEEDHELP = 31,
  COMPLETED = 40,
  FITTINGCOMPLETED = 41,
  READY = 45,
  COLLECTED = 50,
  TODROPPEDOFF = 55,
  CANCELED = 100,
}
